import { Router, Route, browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import { Provider } from 'react-redux'
import { createRoot } from 'react-dom/client'
import React from 'react'

import 'normalize.css'
import 'Styles/reset.css'
import 'Styles/bootstrap-imports.scss'
import '../custom_modules/ml-common-styles/lib/ml-common.css'
import 'Styles/global.css'

import LandingPage from './containers/LandingPage'
import InstructorPage from '../shared/containers/InstructorPage'
import configure from './store'

import getConfig from './lib/params'

const store = configure()
const history = syncHistoryWithStore(browserHistory, store)
const startPage = getConfig().isInstructorView ? InstructorPage : LandingPage

history.listen(() => {
  if (typeof window._arroyoPageLoad !== 'undefined') {
    window._arroyoPageLoad()
  }
})

const root = createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <Router history={history}>
      <Route path="/" component={startPage} />
      {/* MLLC-397: legacy routes from external LMS systems */}
      <Route path="/*.*" component={startPage} />
    </Router>
  </Provider>
)
